import script from "./period.vue?vue&type=script&setup=true&lang=js"
export * from "./period.vue?vue&type=script&setup=true&lang=js"

import "./period.vue?vue&type=style&index=0&id=45570b43&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45570b43"]])

export default __exports__